import { Label, Radio, RadioGroup } from '@blueprintjs/core';
import ShippingSpeedLabel from 'Components/Generic/Shipping/ShippingSpeedLabel';
import { SHIPPING_SPEED } from 'Pages/Requests/Enum';
import PropTypes from 'prop-types';

const ShippingSpeedRadioGroup = ({
  onSelectShipping,
  selectedShippingSpeed,
  label = 'Shipping Speed',
  editable = true,
}) => {
  let labelElement = (
    <Label
      style={{
        fontWeight: 500,
        marginBottom: 0,
        marginRight: 10,
        textAlign: 'center',
      }}>
      {label}
    </Label>
  );
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
      }}>
      {labelElement}
      {editable && (
        <div
          style={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
          }}>
          <RadioGroup
            onChange={onSelectShipping}
            selectedValue={selectedShippingSpeed}
            inline>
            {Object.entries(SHIPPING_SPEED).map(([key, label]) => {
              return (
                <Radio
                  style={{
                    margin: 4,
                  }}
                  key={key}
                  label={label}
                  value={key}
                />
              );
            })}
          </RadioGroup>
        </div>
      )}
      {!editable && (
        <ShippingSpeedLabel shippingSpeedKey={selectedShippingSpeed} />
      )}
    </div>
  );
};

ShippingSpeedRadioGroup.propTypes = {
  onSelectShipping: PropTypes.func,
  selectedShippingSpeed: PropTypes.string,
  label: PropTypes.string,
  editable: PropTypes.bool,
};

export default ShippingSpeedRadioGroup;
